module.exports = __webpack_public_path__ + "img/20200513_155604.95be2e86.jpg";